import React, { useRef } from "react";
import "../../../css/Praplanning/ParaplanningFields.css";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calender.svg";

const ParaplanningDateField = ({
  label,
  required = false,
  value,
  onChange,
  disabled = false,
  error = "",
}) => {
  const inputRef = useRef(null);

  const openCalendar = () => {
    if (disabled) return;

    const input = inputRef.current;

    if (input?.showPicker) {
      input.showPicker();
    } else {
      input?.focus();
      input?.click();
    }
  };

  return (
    <label className="ParaplanningField">
      <span className="ParaplanningField__Label FP_Body">
        {label}
        {required && <span className="ParaplanningField__Required">*</span>}
      </span>

      <div
        className={`ParaplanningField__DateWrapper ${
          error ? "ParaplanningField__DateWrapper--Error" : ""
        } ${disabled ? "ParaplanningField__DateWrapper--Disabled" : ""}`}
      >
        <input
          ref={inputRef}
          className="ParaplanningField__DateInput FP_Content black"
          type="date"
          value={value || ""}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          required={required}
        />

        <button
          type="button"
          className="ParaplanningField__DateIcon FP_Content black"
          onClick={openCalendar}
          disabled={disabled}
          aria-label={`Open ${label} calendar`}
        >
          <CalendarIcon />
        </button>
      </div>

      {error && <span className="ParaplanningField__Error">{error}</span>}
    </label>
  );
};

export default ParaplanningDateField;
